/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountingFormulaRepresentation } from './AccountingFormulaRepresentation';
import {
    AccountingFormulaRepresentationFromJSON,
    AccountingFormulaRepresentationFromJSONTyped,
    AccountingFormulaRepresentationToJSON,
    AccountingFormulaRepresentationToJSONTyped,
} from './AccountingFormulaRepresentation';
import type { ResultType } from './ResultType';
import {
    ResultTypeFromJSON,
    ResultTypeFromJSONTyped,
    ResultTypeToJSON,
    ResultTypeToJSONTyped,
} from './ResultType';

/**
 * 
 * @export
 * @interface AccountingMetricRepresentation
 */
export interface AccountingMetricRepresentation {
    /**
     * 
     * @type {string}
     * @memberof AccountingMetricRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof AccountingMetricRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AccountingMetricRepresentation
     */
    unit: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountingMetricRepresentation
     */
    visible: boolean;
    /**
     * all features that are assigned to the metric
     * @type {Array<string>}
     * @memberof AccountingMetricRepresentation
     */
    licenseFeatures: Array<string>;
    /**
     * 
     * @type {ResultType}
     * @memberof AccountingMetricRepresentation
     */
    resultType: ResultType;
    /**
     * 
     * @type {Array<AccountingFormulaRepresentation>}
     * @memberof AccountingMetricRepresentation
     */
    formulas?: Array<AccountingFormulaRepresentation>;
}



/**
 * Check if a given object implements the AccountingMetricRepresentation interface.
 */
export function instanceOfAccountingMetricRepresentation(value: object): value is AccountingMetricRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('visible' in value) || value['visible'] === undefined) return false;
    if (!('licenseFeatures' in value) || value['licenseFeatures'] === undefined) return false;
    if (!('resultType' in value) || value['resultType'] === undefined) return false;
    return true;
}

export function AccountingMetricRepresentationFromJSON(json: any): AccountingMetricRepresentation {
    return AccountingMetricRepresentationFromJSONTyped(json, false);
}

export function AccountingMetricRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountingMetricRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'unit': json['unit'],
        'visible': json['visible'],
        'licenseFeatures': json['licenseFeatures'],
        'resultType': ResultTypeFromJSON(json['resultType']),
        'formulas': json['formulas'] == null ? undefined : ((json['formulas'] as Array<any>).map(AccountingFormulaRepresentationFromJSON)),
    };
}

export function AccountingMetricRepresentationToJSON(json: any): AccountingMetricRepresentation {
    return AccountingMetricRepresentationToJSONTyped(json, false);
}

export function AccountingMetricRepresentationToJSONTyped(value?: AccountingMetricRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'unit': value['unit'],
        'visible': value['visible'],
        'licenseFeatures': value['licenseFeatures'],
        'resultType': ResultTypeToJSON(value['resultType']),
        'formulas': value['formulas'] == null ? undefined : ((value['formulas'] as Array<any>).map(AccountingFormulaRepresentationToJSON)),
    };
}

